import React, { Component } from 'react'
import moment from 'moment'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import keyBy from 'lodash/keyBy'
import merge from 'lodash/merge'
import pickBy from 'lodash/pickBy'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { isJustGiving, isStaging } from '../../../lib/environment'
import { isRichTextEmpty } from '../../../lib/richText'
import mapTemplate from '../../../lib/mapTemplate'
import { clearSession, fetchSessionPage, fetchSessionUser, selectPage, selectUser } from '../../../store/session'
import { selectAPIParams, selectButtonDefaults, selectHeader, selectLocalisation } from '../../../store/site'
import { getUID } from 'supporticon/utils/params'
import { createMetadata } from 'supporticon/api/metadata'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import * as validators from 'constructicon/lib/validators'

import Button from '../../ui/Button'
import Content from '../../ui/Content'
import CreatePageForm from 'supporticon/components/create-page-form'
import FormState from './FormState'
import Heading from 'constructicon/heading'
import LoginForm from 'supporticon/components/login-form'
import Modal from '../../ui/FlatModal'
import ProviderOauthButton from 'supporticon/components/provider-oauth-button'
import ResetPassword from 'supporticon/components/reset-password-form'
import RichText from '../../ui/RichText'
import Section from '../../ui/Section'
import SignupForm from 'supporticon/components/signup-form'
import SingleSignOnLink from 'supporticon/components/single-sign-on-link'
import Success from '../../ui/Success'
import TeamRegistration from './TeamRegistration'

class RegisterForm extends Component {
  constructor (props) {
    super(props)
    this.handleAuthSuccess = this.handleAuthSuccess.bind(this)
    this.handleCreatePageSuccess = this.handleCreatePageSuccess.bind(this)
    this.handleLogout = this.handleLogout.bind(this)
    this.renderAuthForm = this.renderAuthForm.bind(this)
    this.renderAuthProviders = this.renderAuthProviders.bind(this)
    this.renderCreatePageForm = this.renderCreatePageForm.bind(this)
    this.renderSuccess = this.renderSuccess.bind(this)

    this.state = {
      view: 'signup',
      modal: !!props.page
    }
  }

  componentDidUpdate ({ header, page, user }, { view }) {
    const viewChanged =
      page !== this.props.page ||
      user !== this.props.user ||
      view !== this.state.view

    if (typeof window === 'undefined') {
      return
    }

    if (viewChanged) {
      const offset = header.sticky === 'yes' ? document.querySelector('#header').offsetHeight : 0
      setTimeout(() => window.scrollTo(0, this.refs.root.offsetTop - offset))
      this.addStepToUrl()
    }
  }

  componentDidMount () {
    this.addStepToUrl()
  }

  addStepToUrl () {
    const { page, user } = this.props
    const { view } = this.state

    if (page) {
      window.location.hash = 'register-success'
      return
    }

    if (user) {
      window.location.hash = 'create-page'
      return
    }

    if (view !== 'signup') {
      window.location.hash = view
    }
  }

  handleAuthSuccess (data) {
    const token = data.token || data.access_token
    this.props.fetchSessionUser({ token })
  }

  mapFieldName (field, index) {
    return field.name ? field.name : `custom_field_${index}`
  }

  handleCreatePageSuccess (page, fields) {
    const { fetchSessionPage, items = [], user } = this.props
    const fieldNames = items.map(this.mapFieldName)
    const metadata = pickBy(fields, (_, key) => find(fieldNames, field => field === key))

    Promise.resolve()
      .then(() => fetchSessionPage(page))
      .then(data => {
        return !isEmpty(metadata) && createMetadata({
          token: user.token,
          id: isJustGiving() ? data.pageShortName : data.uuid,
          app: isStaging() ? process.env.MDS_JG_STAGING_APP_ID : process.env.MDS_JG_PROD_APP_ID,
          metadata
        })
      })
      .then(() => this.setState({ modal: true }))
  }

  handleLogout (data) {
    this.setState({ modal: false, view: 'signup' })
    this.props.clearSession()
  }

  getCharitySearchOption (value) {
    switch (value) {
      case 'Yes':
        return 'search'
      case 'Yes - Dropdown':
        return 'select'
      default:
        return false
    }
  }

  renderAuthProviders (method) {
    const {
      button,
      classNames,
      clientId,
      facebook,
      mapmyfitness,
      oauthMethod,
      redirectUri,
      strava,
      styles
    } = this.props

    if (isJustGiving()) { return null }

    const providers = [
      facebook === 'Yes' && 'facebook',
      mapmyfitness === 'Yes' && 'mapmyfitness',
      strava === 'Yes' && 'strava'
    ].filter((key) => key)

    return providers.length > 0 && (
      <div className={classNames.providers}>
        {providers.map((provider, i) => (
          <ProviderOauthButton
            block
            key={provider}
            provider={provider}
            label={`${method} with ${provider}`}
            clientId={clientId || process.env.EDH_CLIENT_ID}
            redirectUri={redirectUri || process.env.EDH_REDIRECT_URI}
            onSuccess={this.handleAuthSuccess}
            styles={styles.provider}
            useLocalStorage={oauthMethod === 'Advanced'}
            {...button}
          />
        ))}
        <Heading tag='h3' size={0}>{method} with Email</Heading>
      </div>
    )
  }

  renderAuthForm () {
    const {
      clientId,
      country,
      foreground,
      loginLabel,
      loginTitle,
      resetPasswordLabel,
      resetPasswordTitle,
      signupLabel,
      signupTitle,
      styles
    } = this.props

    const { modal } = this.state

    const platform = isJustGiving() ? 'JustGiving' : 'everydayhero'
    const platformWithArticle = isJustGiving() ? 'a JustGiving' : 'an everydayhero'
    const countryCode = country === 'gb' ? 'uk' : country

    switch (this.state.view) {
      case 'reset-password':
        return (
          <FormState
            state='reset-password'
            foreground={foreground}
            links={[{ label: 'Back to login', onClick: () => this.setState({ view: 'login' }) }]}>
            <Heading styles={styles.heading}>{resetPasswordTitle || `Reset your ${platform} password`}</Heading>
            <ResetPassword
              clientId={clientId || process.env.EDH_CLIENT_ID}
              formComponent={{ styles: styles.form }}
              onSuccess={(result) => this.setState({ modal: true })}
              submit={resetPasswordLabel || 'Send reset password instructions'}
            />
            <Modal
              contentLabel='Email sent!'
              isOpen={modal}
              onRequestClose={() => this.setState({ modal: false, view: 'login' })}
              spacing={1.5}>
              <Success title='Email sent!'>
                <RichText children={[
                  { type: 'paragraph', text: `If ${platformWithArticle} account exists with the email address entered, you will receive an email within the next few minutes.` },
                  { type: 'paragraph', text: 'It contains instructions for changing your password.' }
                ]} />
              </Success>
            </Modal>
          </FormState>
        )
      case 'login':
        return (
          <FormState
            state='login'
            foreground={foreground}
            links={[
              { label: `Forgot your ${platform} password?`, onClick: () => this.setState({ view: 'reset-password' }) },
              { label: `Need ${platformWithArticle} account?`, onClick: () => this.setState({ view: 'signup' }) }
            ]}>
            <Heading styles={styles.heading}>{loginTitle || `Login to ${platform}`}</Heading>
            {this.renderAuthProviders('Login')}
            <LoginForm
              clientId={clientId || process.env.EDH_CLIENT_ID}
              country={countryCode}
              formComponent={{ styles: styles.form }}
              onSuccess={this.handleAuthSuccess}
              submit={loginLabel || 'Log in'}
            />
          </FormState>
        )
      default:
        const fields = {
          target: {
            label: isJustGiving()
              ? <span>I agree to JustGiving's <a href='https://www.justgiving.com/info/terms-of-service/' target='_blank'>terms of service</a> and <a href='https://www.justgiving.com/info/privacy/' target='_blank'>privacy policy</a></span>
              : <span>I agree to Everydayhero's <a href='https://everydayhero.com/uk/terms/privacy' target='_blank'>privacy policy</a> and <a href='https://everydayhero.com/au/terms/' target='_blank'>terms & conditions</a></span>,
            type: 'checkbox',
            required: true,
            validators: [
              validators.required(`You must agree to ${isJustGiving() ? 'JustGiving' : 'Everydayhero'}'s terms and conditions`)
            ]
          }
        }

        return (
          <FormState
            state='signup'
            foreground={foreground}
            links={[{ label: `Already have ${platformWithArticle} account?`, onClick: () => this.setState({ view: 'login' }) }]}>
            <Heading styles={styles.heading}>{signupTitle || `Create ${platformWithArticle} account`}</Heading>
            {this.renderAuthProviders('Sign up')}
            <SignupForm
              clientId={clientId || process.env.EDH_CLIENT_ID}
              country={countryCode}
              fields={fields}
              formComponent={{ styles: styles.form }}
              onSuccess={this.handleAuthSuccess}
              submit={signupLabel || 'Sign up (Step 1 of 2)'}
            />
          </FormState>
        )
    }
  }

  renderCreatePageForm () {
    const {
      addressCountry,
      campaignId,
      charityId,
      classNames,
      clientId,
      createPageLabel,
      createPageTitle,
      customCode1,
      customCode2,
      customCode3,
      eventId,
      foreground,
      gdprLabel,
      includeCharitySearch,
      items = [],
      pageEventDateLabel,
      pageNameLabel,
      pageTargetLabel,
      showAddress,
      showEventDate,
      showFitnessGoal,
      showName,
      showTarget,
      styles,
      terms,
      uom,
      user = {}
    } = this.props

    const hasCustomCodes = isJustGiving() && (customCode1 || customCode2 || customCode3)

    const fields = merge({}, !isJustGiving() && {
      birthday: {
        showSelects: true,
        placeholder: null,
        order: 2,
        max: moment().subtract(1, 'day').format(moment.HTML5_FMT.DATE),
        validators: [
          validators.required('Please enter your date of birth'),
          val => !!val && moment(val).isAfter(moment().subtract(1, 'day').startOf('day')) && 'Please select a date in the past'
        ]
      }
    },
    showName === 'Yes' && {
      name: {
        label: pageNameLabel || 'Fundraising page name',
        type: 'text',
        placeholder: `${user.firstName}'s page`,
        required: true,
        order: 1,
        validators: [
          validators.required('Please enter a page name')
        ]
      }
    },
    showTarget === 'Yes' && {
      target: {
        label: pageTargetLabel || 'Fundraising target',
        type: 'number',
        required: true,
        order: 1,
        validators: [
          validators.required('Please enter a fundraising target')
        ],
        styles: styles.target
      }
    },
    showEventDate === 'Yes' && {
      [isJustGiving() ? 'eventDate' : 'campaignDate']: {
        label: pageEventDateLabel || 'Event date',
        type: 'date',
        required: true,
        order: 2,
        validators: [
          validators.required('Please enter an event date')
        ]
      }
    },
    showFitnessGoal === 'Yes' && {
      fitnessGoal: {
        label: `Distance goal (in ${uom})`,
        type: 'number',
        required: true,
        order: 2,
        validators: [
          validators.required('Please enter a fitness goal')
        ],
        styles: styles.fitnessGoal
      }
    },
    !isEmpty(gdprLabel) && {
      directMarketingConsent: {
        label: <RichText styles={styles.termsLabel}>{gdprLabel}</RichText>,
        type: 'checkbox',
        order: 3,
        styles: styles.termsCheckbox
      }
    },
    !isRichTextEmpty(terms) && {
      terms: {
        label: <RichText styles={styles.termsLabel}>{terms}</RichText>,
        type: 'checkbox',
        required: true,
        order: 4,
        validators: [
          validators.required('You must agree to the terms & conditions.')
        ],
        styles: styles.termsCheckbox
      }
    },
    hasCustomCodes && {
      customCodes: {
        type: 'hidden',
        initial: {
          customCode1,
          customCode2,
          customCode3
        }
      }
    }, keyBy(items.map((field, index) => {
      const fieldProps = {
        name: this.mapFieldName(field, index),
        label: <RichText styles={styles.label}>{field.label}</RichText>,
        type: field.type,
        required: field.required === 'Yes',
        order: field.order,
        validators: field.required === 'Yes' ? [
          validators.required(field.validationLabel || 'This field is required')
        ] : []
      }

      switch (field.type) {
        case 'label':
          return {
            ...fieldProps,
            children: (
              <div className={classNames.labelWrapper}>
                <RichText styles={styles.label}>{field.label}</RichText>
              </div>
            )
          }
        case 'select':
          return {
            ...fieldProps,
            options: field.options.split(',').map(option => ({ label: option.trim(), value: option.trim() }))
          }
        case 'date':
          return {
            ...fieldProps,
            showSelects: true
          }
        default:
          return fieldProps
      }
    }), 'name'))

    return (
      <FormState
        state='create-page'
        foreground={foreground}
        links={[{ label: 'Log out', onClick: this.handleLogout }]}>
        <Heading styles={styles.heading}>{mapTemplate(createPageTitle || 'Create Fundraising Page', { user })}</Heading>
        <CreatePageForm
          campaignId={campaignId || getUID(this.props.campaign)}
          charityId={charityId || getUID(this.props.charity)}
          clientId={clientId || process.env.EDH_CLIENT_ID}
          country={addressCountry !== 'none' ? addressCountry : undefined}
          eventId={eventId || getUID(this.props.event)}
          fields={fields}
          formComponent={{ styles: styles.createPageForm }}
          includeAddress={showAddress === 'Yes'}
          includeCharitySearch={this.getCharitySearchOption(includeCharitySearch)}
          includePhone={!user.phone}
          onSuccess={this.handleCreatePageSuccess}
          submit={createPageLabel || 'Create Page (Step 2 of 2)'}
          token={user.token}
        />
      </FormState>
    )
  }

  renderSuccess () {
    const {
      button,
      campaignId,
      charityId,
      foreground,
      includeTeam,
      page,
      styles,
      successButtonLabel,
      successCopy,
      successTitle,
      successTeamCopy,
      successCreateTeamButtonLabel,
      successJoinTeamButtonLabel,
      user
    } = this.props

    return (
      <Success id='register-success' title={mapTemplate(successTitle || 'Congratulations <%= userName %>!', { user, page })}>
        {successCopy.length > 0 && (
          <RichText styles={styles.copy}>
            {successCopy.map((item) => ({
              ...item,
              text: mapTemplate(item.text, { user, page })
            }))}
          </RichText>
        )}
        <SingleSignOnLink
          label={mapTemplate(successButtonLabel || 'Visit your page', { user, page })}
          token={user.token}
          url={page.url}
          size={0.5}
          styles={styles.button}
          {...button}
        />
        {includeTeam === 'Yes' && (
          <TeamRegistration
            user={user}
            page={page}
            campaign={campaignId || this.props.campaign}
            charity={charityId || this.props.charity}
            successTeamCopy={successTeamCopy}
            successCreateTeamButtonLabel={successCreateTeamButtonLabel}
            successJoinTeamButtonLabel={successJoinTeamButtonLabel}
          />
        )}
        <Button
          background='transparent'
          foreground={foreground}
          onClick={this.handleLogout}
          styles={styles.link}
          tag='button'>
          Log out
        </Button>
      </Success>
    )
  }

  render () {
    const {
      alignment,
      background,
      backgroundImage,
      copy,
      copyAlignment,
      foreground,
      layout,
      page,
      size,
      spacing,
      subtitle,
      title,
      titleForeground,
      user
    } = this.props

    return (
      <div ref='root'>
        <Section
          alignment={alignment}
          backgroundImage={backgroundImage}
          background={background}
          foreground={foreground}
          size={size}
          spacing={spacing}>

          <Content
            copy={copy}
            copyAlignment={copyAlignment}
            layout={layout}
            subtitle={subtitle}
            title={title}
            titleForeground={titleForeground}>

            {page ? this.renderSuccess() : user
              ? this.renderCreatePageForm()
              : this.renderAuthForm()
            }
          </Content>
        </Section>
      </div>
    )
  }
}

RegisterForm.defaultProps = {
  clientId: process.env.EDH_CLIENT_ID,
  redirectUri: process.env.EDH_REDIRECT_URI,
  includeTeam: 'Yes'
}

const mapState = (store) => {
  const { apiParams } = selectAPIParams(store)

  return {
    ...apiParams,
    ...selectLocalisation(store),
    header: selectHeader(store),
    button: selectButtonDefaults(store),
    user: selectUser(store),
    page: selectPage(store)
  }
}

const mapDispatch = { clearSession, fetchSessionUser, fetchSessionPage }

export default compose(
  connect(mapState, mapDispatch),
  withStyles(styles)
)(RegisterForm)



// WEBPACK FOOTER //
// ./components/slices/Registration/index.js